<template>
  <div class="col-auto tabs tw-rounded-[10px] tw-bg-greyc-4 tw-p-[2px]">
    <q-tabs
      dense
      no-caps
      inline-label
      v-model="tab"
      class="tab-info"
      indicator-color="transparent"
    >
      <q-tab
        name="current"
        label="Atendimento"
        icon="mdi-account-voice"
      >
        <q-tooltip>Atendimento</q-tooltip>
      </q-tab>
      <q-tab
        name="history"
        label="Histórico"
        icon="mdi-history"
        v-if="showHistory"
      >
        <q-tooltip>Histórico</q-tooltip>
      </q-tab>
    </q-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      tab: 'current'
    }
  },

  computed: {
    ...mapGetters({
      flag: 'agentModule/flag'
    }),

    showHistory () {
      return this.flag('attendanceHistory') === true
    }
  },

  watch: {
    tab (tab) {
      this.$emit('change-view', tab)
    }
  }
}
</script>

<style lang="sass" >

.tabs
  max-width: 585px !important

.tab-info
  color: #01253C
  font-size: 13px
  line-height: 14px
  font-weight: 400

  .q-tab
    padding: 0 10px
    min-height: 26px

  .q-tab--active
    color: #1769B6
    font-weight: 600
    background-color: #fff
    border-radius: 8px
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08)

  .q-tab .q-tab__icon
    display: none

@media (max-width: 760px)
  .tab-info

    .q-tab
      padding: 0 6px

    .q-tab__content
      min-width: 0

    .q-tab__label
      display: none

    .q-tab .q-tab__icon
      display: block
      width: 18px
      height: 18px
      font-size: 18px
</style>
